/*
 * ----------------------------------------------------------------------------
 * SEARCH PREFIX MATCHING (wildcard)
 * ----------------------------------------------------------------------------
 *
 * The storefront full-text search on the results page matches whole words only,
 * so a query like "mund" never matches the product "Munddusche". Predictive
 * search (the drawer dropdown) prefix-matches and does find it, which is the
 * inconsistency shoppers hit. We reconcile the two by appending "*" to each term
 * when a site search form is submitted, so /search also prefix-matches across all
 * fields. The trailing "*" is stripped from the displayed term in main-search.liquid.
 */
(function () {
  'use strict';

  function addWildcard(value) {
    return value
      .trim()
      .split(/\s+/)
      .map(function (term) {
        // Drop any existing trailing "*" (a re-search from the results page keeps
        // the wildcard in the input) so we never accumulate "mund**", then add one.
        return term.replace(/\*+$/, '') + '*';
      })
      .join(' ');
  }

  // Capture phase so the value is rewritten before the form serializes for its
  // native GET navigation. Covers the search drawer, the results-page re-search
  // and any other role="search" form, without touching the predictive dropdown
  // (which reads the raw value on input, not on submit).
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || typeof form.matches !== 'function' || !form.matches('form[role="search"]')) {
        return;
      }
      var input = form.elements && form.elements['q'];
      if (!input || input.value.trim() === '') {
        return;
      }
      input.value = addWildcard(input.value);
    },
    true
  );
})();
